module.exports = __webpack_public_path__ + "static/media/plus.db7eca6f.svg";